import { BaseController } from '../../../../common/base/controller';

class PartnerItemController extends BaseController {
  constructor(controllerService, ticketReaderFactory) {
    'ngInject';
    super({ controllerService, ticketReaderFactory });
  }

  $onInit() {
    this.toggleable = this.partner.partner;
  }

  toggleDetailView() {
    if (this.toggleable) {
      this.showPartnerDetails = !this.showPartnerDetails;
    }
  }

  getPartnerAddress(partner) {
    if (!partner.partner) {
      return this.$translate.instant('app.partnerList.noPartner');
    }

    return `${partner.partner.name} - ${partner.partner.address} - ${partner.partner.postcode} - ${partner.partner.city}`;
  }

  select() {
    if (!this.readonly) {
      this.onSelect();
    }
  }
}

export default PartnerItemController;
